(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-description"] && !window.DesignMode) return;
  try {
    
const toggleButton = document.getElementById('toggleButton');
  const content = document.getElementById('col-desc');

  toggleButton.addEventListener('click', function() {
    if (content.classList.contains('show-more')) {
      content.classList.remove('show-more');
      toggleButton.textContent = 'Read More';
    } else {
      content.classList.add('show-more');
      toggleButton.textContent = 'Read Less';
    }
  });

  } catch(e) { console.error(e); }
})();
})();
